import starIcon from '@/assets/icons/form-and-reviews/star.svg';

import styles from './ReviewSlide.module.scss';

interface ReviewSlideProps {
  photo: string;
  name: string;
  children: React.ReactNode;
}

export function ReviewSlide({ photo, name, children }: ReviewSlideProps) {
  return (
    <div className={styles.reviewSlide}>
      <div className={styles.reviewSlide__header}>
        <div className={styles.reviewSlide__photo}>
          <img src={photo} alt={name} loading="lazy" />
        </div>
        <h3 className={styles.reviewSlide__name}>{name}</h3>
        <div className={styles.reviewSlide__grade}>
          <div className={styles.reviewSlide__star}>
            <img src={starIcon} alt="Star" />
          </div>
          <div className={styles.reviewSlide__star}>
            <img src={starIcon} alt="Star" />
          </div>
          <div className={styles.reviewSlide__star}>
            <img src={starIcon} alt="Star" />
          </div>
          <div className={styles.reviewSlide__star}>
            <img src={starIcon} alt="Star" />
          </div>
          <div className={styles.reviewSlide__star}>
            <img src={starIcon} alt="Star" />
          </div>
        </div>
      </div>
      <p className={styles.reviewSlide__text}>{children}</p>
    </div>
  );
}
